import bs58 from 'bs58';
import { NetworkType, AddressSelectionMode } from "../../types";
export const name = 'Solana';
export class SolanaAddressUtilsProvider {
    constructor() {
        this.providerName = name;
        this.networkType = NetworkType.Solana;
        this.label = 'Solana';
        this.selection = AddressSelectionMode.Networks;
        this.defaultScope = 'primary';
    }
    supportsNetwork(network) {
        return network.type === NetworkType.Solana;
    }
    isValidAddress(props) {
        const { address } = props;
        if (!address) {
            return false;
        }
        try {
            const decoded = bs58.decode(address);
            return decoded.length === 32;
        }
        catch {
            return false;
        }
    }
    addressFormat(props) {
        return props.address ?? '';
    }
}
